module.exports = __webpack_public_path__ + "static/img/icono_reproduciendo.fc573369.svg";